/**
 * Navigate the browser programmatically — always a **full page load**, never a router
 * push. For destinations served by another app behind the same hostname (`/depart` and
 * friends, from ui-react), a client-side transition would resolve inside Next and 404.
 *
 * Two shapes need it: `CrawlSafeLink`, which renders no `href` on purpose
 * (→ `invariants.md#no-transient-search-links`), and the search-widget submit handlers,
 * where navigation is conditional on validation and the URL is only known at submit.
 */
export function browserNavigate(url: string, { newTab }: { newTab?: boolean } = {}): void {
    if (newTab) {
        // `noopener` goes on the handle, not in the features string: a features-string
        // `noopener` makes `window.open` return null *even on success*, leaving no way to
        // tell a blocked popup from an opened one. Same-origin target, so it is equivalent.
        // No `noreferrer` — it would strip the `Referer` the destination attributes
        // internal traffic by, making every CTA click look like direct traffic.
        const opened = window.open(url, '_blank')
        if (opened) {
            opened.opener = null
            return
        }
        // In-app webviews block `window.open` outright; without this fall-through the
        // control would be dead there.
    }
    window.location.assign(url)
}
